// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fc5c9897","513":"dddfe64a","703":"8843f4c6","787":"f01a1490"}[chunkId] + ".chunk.js";
};